import { Box, Tab, Tabs } from '@mui/material';
import { Outlet } from 'react-router-dom';
import IncTabPanel from './inc-page-tab-panel/inc-page-tab-panel.component';
import { useIncPageTabPanelsContext } from './inc-page-tab-panels.context';
import TabInfo from './tab-info/tab-info.component';

const IncPageTabPanels = () => {
  const { tabs, tabIndex, handleTabChange } = useIncPageTabPanelsContext();

  return (
    <Box>
      <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable">
        {tabs.map(tab => (
          <Tab
            label={tab.label}
            key={tab.label}
            icon={
              tab.tooltip ? (
                <TabInfo
                  label={tab.label}
                  body={tab.tooltip}
                  data-testid={`TabInfo.${tab.path}`}
                />
              ) : undefined
            }
            iconPosition="end"
            // An icon+label Tab gets MUI's stacked-icon sizing (min-height
            // 72px); the inline info icon should keep the standard height.
            sx={tab.tooltip ? { minHeight: 48 } : undefined}
          />
        ))}
      </Tabs>
      <IncTabPanel value={tabIndex} index={tabIndex}>
        <Outlet />
      </IncTabPanel>
    </Box>
  );
};

export default IncPageTabPanels;
